import { render, staticRenderFns } from "./TcAlphaGenerator.vue?vue&type=template&id=9a4e64e2&scoped=true&"
import script from "./TcAlphaGenerator.vue?vue&type=script&lang=js&"
export * from "./TcAlphaGenerator.vue?vue&type=script&lang=js&"
import style0 from "./TcAlphaGenerator.vue?vue&type=style&index=0&id=9a4e64e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4e64e2",
  null
  
)

export default component.exports